var _excluded = ["color"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { createIcon } from '@chakra-ui/icon';
import { forwardRef } from '@chakra-ui/system';
import * as React from 'react';
var EVBadge = createIcon({
  displayName: 'EVBadgeIcon',
  viewBox: '0 0 36 36',
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("circle", {
    cx: "18",
    cy: "18",
    fill: "currentColor",
    r: "18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5983 18.8457L20.7083 6.56926C20.9826 6.23625 21.517 6.51341 21.4028 6.92944L18.0328 19.2059C17.9851 19.3796 17.8272 19.5 17.6471 19.5H10.9071C10.569 19.5 10.3834 19.1067 10.5983 18.8457Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3056 17.1646L14.3072 29.6294C14.0241 29.9503 13.5028 29.6624 13.6236 29.2519L17.2897 16.7871C17.3397 16.6169 17.496 16.5 17.6734 16.5L25.0056 16.5C25.3501 16.5 25.5335 16.9064 25.3056 17.1646Z",
    fill: "white",
    stroke: "white"
  }))
});
export var EVBadgeIcon = forwardRef((props, ref) => {
  var rest = _objectWithoutPropertiesLoose(props, _excluded);

  return /*#__PURE__*/React.createElement(EVBadge, _extends({
    color: "green.500",
    ref: ref
  }, rest));
});
//# sourceMappingURL=EVBadge.js.map